module.exports = __webpack_public_path__ + "img/discount-percent-fill.8e4d32a4.svg";